var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#282B2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3163 19.52H23.6837C23.3002 19.5306 22.9246 19.6312 22.5873 19.8139C22.2499 19.9965 21.9602 20.256 21.7417 20.5714L17.5835 26.3314C17.2748 26.768 17.1206 27.2951 17.1454 27.8293C17.1702 28.3635 17.3727 28.8741 17.7206 29.28L30.1951 43.6571C30.4086 43.9325 30.6823 44.1554 30.9951 44.3085C31.3079 44.4619 31.6516 44.5414 32 44.5414C32.3483 44.5414 32.692 44.4619 33.0048 44.3085C33.3177 44.1554 33.5913 43.9325 33.8049 43.6571L46.2793 29.28C46.6272 28.8741 46.8297 28.3635 46.8546 27.8293C46.8793 27.2951 46.7252 26.768 46.4164 26.3314L42.2583 20.5714C42.0397 20.256 41.7501 19.9965 41.4128 19.8139C41.0754 19.6312 40.6996 19.5306 40.3163 19.52Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8113 19.4971L25.2341 28.1371L31.9998 44.4799",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2571 19.4971L38.8114 28.1371L32 44.4799",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1885 28.1372H46.8113",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile_2.05360f188a0df6ca4678d72568e0f49f.svg";
export { ForwardRef as ReactComponent };